import { render, staticRenderFns } from "./ActionsAndHelp.vue?vue&type=template&id=216350a0&scoped=true&"
import script from "./ActionsAndHelp.vue?vue&type=script&lang=js&"
export * from "./ActionsAndHelp.vue?vue&type=script&lang=js&"
import style0 from "./ActionsAndHelp.vue?vue&type=style&index=0&id=216350a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216350a0",
  null
  
)

export default component.exports